<template>
    <div class="cities-seo-list" v-if="lang && cities_list_event">
        <div v-if="cities_list_event.length != 0">
            <strong>{{ lang.title.cities_list|capitalize }}:</strong>
            <span v-for="city in cities_list_event" :key="city.id">
                <a :href="city.url">{{ city.title }}</a>
            </span>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        cities_list: {
            type: Array,
            required: false,
        },
    },

    data() {
        return {
            cities_list_event: this.cities_list
        }
    },

    computed: {
        lang() {
            return this.$root.lang.estates_list
        }
    },

    mounted() {
        window.events.$on('list.cities_list', event => {
            this.cities_list_event = event
        })
    }

}
</script>
